import { render, staticRenderFns } from "./centerAddTitle.vue?vue&type=template&id=5adf9568&scoped=true&"
var script = {}
import style0 from "./centerAddTitle.vue?vue&type=style&index=0&id=5adf9568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adf9568",
  null
  
)

export default component.exports